import RadioGroup from 'packages/radio/src/radio-group';

export default RadioGroup;



// WEBPACK FOOTER //
// ./packages/radio-group/index.js